// assets
import { IconChecklist, IconSparkles, IconTemplate } from '@tabler/icons-react';

// types
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS - AI (A6) ||============================== //
// AI Gateway [STD-AI]: playground (tek giriş noktası), versiyonlu prompt kayıtları,
// insan onayı kuyruğu.

const ai: NavItemType = {
  id: 'ai',
  title: 'ai', // react-intl key (utils/locales/en.json) - i18n-ready [STD-DRIFT]
  icon: IconSparkles,
  type: 'group',
  requiredModule: 'ai_assist',
  children: [
    {
      id: 'ai-playground',
      title: 'ai-playground',
      icon: IconSparkles,
      type: 'item',
      url: '/ai/playground',
      module: 'ai.completions'
    },
    {
      id: 'ai-prompts',
      title: 'ai-prompts',
      icon: IconTemplate,
      type: 'item',
      url: '/ai/prompts',
      module: 'ai.prompts'
    },
    {
      id: 'ai-approvals',
      title: 'ai-approvals',
      icon: IconChecklist,
      type: 'item',
      url: '/ai/approvals',
      module: 'ai.approvals'
    }
  ]
};

export default ai;
